// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"241":"1f964c31","522":"668321f7","557":"53db490d","627":"e11b6c24","697":"11a7b036","706":"9c3f1f2b"}[chunkId] + ".chunk.css";
};